// extracted by mini-css-extract-plugin
export var actionButton = "_b5-1";
export var actionButtons = "_b5-2";
export var actions = "_b5-0";
export var aiUnread = "_b5-10";
export var alignCenter = "_b5-h";
export var backWrapper = "_b5-3";
export var cellContainer = "_b5-4";
export var checkboxContainer = "_b5-5";
export var contentContainer = "_b5-6";
export var contentHeader = "_b5-8";
export var conversationsTableWrapper = "_b5-s";
export var draftReplyBadgeContainer = "_b5-m";
export var dropdownItem = "_b5-b";
export var dropdownItemsContainer = "_b5-a";
export var dropdownTitle = "_b5-c";
export var errorIcon = "_b5-7";
export var filter = "_b5-d";
export var gray = "_b5-i";
export var headerActionButtons = "_b5-e";
export var headerCheckboxContainer = "_b5-f";
export var icon = "_b5-j";
export var menuContainer = "_b5-k";
export var noMoreTicketsIcon = "_b5-12";
export var noMoreTicketsSubText = "_b5-13";
export var oneLine = "_b5-l";
export var optionsButton = "_b5-n";
export var plus = "_b5-o";
export var portalButtonsWrapper = "_b5-g";
export var red = "_b5-p";
export var scrolledTop = "_b5-9";
export var search = "_b5-q";
export var selectedConversationsCount = "_b5-r";
export var spinner = "_b5-t";
export var strong = "_b5-u";
export var summaryCell = "_b5-v";
export var tableContainer = "_b5-11";
export var tagContainer = "_b5-w";
export var threeDots = "_b5-x";
export var twoLines = "_b5-y";
export var unread = "_b5-z";